import { P2GBox } from '@parcel2go/core-ui';
import { ReactNode } from 'react';

export const FancySelection = ({
  children,
  selected,
  onClick,
  isMenu
}: {
  children: ReactNode;
  selected?: boolean;
  onClick?: () => void;
  isMenu?: boolean;
}) => (
  <P2GBox
    sx={(t) => ({
      position: 'relative',
      borderRadius: t.spacing(1.5),
      p: t.spacing(0.25, 0.5),
      background: selected && !isMenu ? t.palette.grey[100] : undefined,
      transition: 'background 0.8s'
    })}
  >
    <P2GBox
      p={1}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={(t) => ({
        width: '100%',
        cursor: 'pointer',
        '&:hover:before': {
          opacity: 1
        },
        '&:before': {
          content: '""',
          position: 'absolute',
          left: '-5px',
          width: '4px',
          background: t.palette.primary.main,
          height: '35px',
          borderRadius: '0 4px 4px 0',
          transition: 'all 0.5s',
          opacity: selected ? 1 : 0
        }
      })}
      onClick={onClick}
    >
      {children}
    </P2GBox>
  </P2GBox>
);
